export default __webpack_public_path__ + "static/media/ambient.7af471ed.m4a";